import React, { Component } from 'react';
import { FORMAT_NUMBER, CURRENCY, SYMBOL, _ROUND } from '../libs/utils/Const';
import moment from 'moment';
import '../css/formats.css';

class SaleDetailsModal extends Component {

    TaxTotal = (line)=>{
        return _ROUND(parseFloat((line.Price * line.Quantity).toFixed(2)) * (line.VatPrcnt / 100))
    }

    render() {
        const { DocLines, DocHeader } = this.props
        return (
            <div>
                <div className="modal fade" id="saleDetailsModal" data-backdrop="static" data-keyboard="true" tabIndex="-1" aria-labelledby="saleDetailsModalLabel" aria-hidden="true" >
                    <div className="modal-dialog modal-xl" >
                        <div className="modal-content">
                            <div className="modal-body">
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close" style={{ marginTop: "-8px" }}>
                                    <span aria-hidden="true" data-dismiss="modal" data-toggle="modal" data-target="#salesModal">&times;</span>
                                </button>
                                <div className='m-4'>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">

                                                <div className='col-4 text-left'>
                                                    <div className="input-group ">
                                                        <div className="input-group-prepend">
                                                            <span className="input-group-text" ><strong>Folio</strong></span>
                                                        </div>
                                                        <input type="text" className="form-control" disabled placeholder={!!DocHeader ? DocHeader.infoByFolio.folio : ''} />
                                                    </div>
                                                </div>
                                                <div className="col-4 text-left">
                                                    <div className="input-group">
                                                        <div className="input-group-prepend">
                                                            <span className="input-group-text"><strong>Cliente</strong></span>
                                                        </div>
                                                        <input type="text" className="form-control" disabled placeholder={!!DocHeader ? DocHeader.responseHeader.CardCode : ''} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='row'>
                                                <div className='col-4 mb-4 mt-4'>
                                                    <div className="input-group">
                                                        <div className="input-group-prepend">
                                                            <span className="input-group-text"><strong>Fecha</strong></span>
                                                        </div>
                                                        <input type="text" className="form-control" disabled placeholder={!!DocHeader ? moment(DocHeader.responseHeader.DocDate).format('MM/DD/YYYY') : ''} />
                                                    </div>
                                                </div>
                                                <div className='col-4 mb-4 mt-4'>
                                                    <div className="input-group">
                                                        <div className="input-group-prepend">
                                                            <span className="input-group-text"><strong>Hora</strong></span>
                                                        </div>
                                                        <input type="text" className="form-control" disabled placeholder={!!DocHeader ?  DocHeader.infoByFolio.docTime.toString().length > 4 ? DocHeader.infoByFolio.docTime : moment(DocHeader.infoByFolio.docTime).format('LT') : ''} />
                                                    </div>
                                                </div>
                                                <div className="col-4 mb-4 mt-4">
                                                    <div className="input-group">
                                                        <div className="input-group-prepend">
                                                            <span className="input-group-text"><strong>Vendedor ID: </strong></span>
                                                        </div>
                                                        <input type="text" className="form-control" disabled placeholder={!!DocHeader ? DocHeader.infoByFolio.userID : ''} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='card scrollFacCollect' style={{ maxHeight: "335px" }}>
                                                <table className="table table-striped table-hover">
                                                    <thead>
                                                        <tr>
                                                            <th className="col-2 text-center" scope="col">
                                                                Código
                                                            </th>
                                                            <th className="col-6 text-center" scope="col">
                                                                Nombre
                                                            </th>
                                                            <th className="col-2 text-center" scope="col">
                                                                Cantidad
                                                            </th>
                                                            <th className="col-2 text-center" scope="col">
                                                                Precio
                                                            </th>
                                                            <th className="col-2 text-center" scope="col">
                                                                Importe
                                                            </th>
                                                            <th className="col-2 text-center" scope="col">
                                                                Total
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {!!DocLines && DocLines.length > 0 &&
                                                            DocLines.map((line, index) => {
                                                                return (
                                                                    <tr key={index}>
                                                                        <td className="col-2 text-center">
                                                                            <strong>{line.ItemCode ?? ''}</strong>
                                                                        </td>
                                                                        <td className="col-2 text-center">{line.Dscription ?? ''}</td>
                                                                        <td className="col-2 text-center">{CURRENCY + ' ' + FORMAT_NUMBER.new( line.Quantity ?? '')}</td>
                                                                        <td className="col-2 text-center">{CURRENCY + ' ' + FORMAT_NUMBER.new( line.Price ?? '')}</td>
                                                                        <td className="col-2 text-center">{CURRENCY + ' ' + FORMAT_NUMBER.new( line.Price ?  this.TaxTotal(line): '')} </td>
                                                                        <td className="col-2 text-center">{CURRENCY + ' ' + FORMAT_NUMBER.new( line.LineTotal ?? '')}</td>
                                                                    </tr>
                                                                );
                                                            })
                                                        }

                                                    </tbody>
                                                </table>
                                            </div>
                                            <div className="row mt-3">
                                                <div className="col-9">
                                                </div>
                                                <div className="col-3 text-right">

                                                    <div className="input-group">
                                                        <div className="input-group-prepend">
                                                            <span className="input-group-text"><strong>Total</strong></span>
                                                        </div>
                                                        <input type="text" className="form-control text-right" disabled placeholder={`${!!DocHeader ? CURRENCY + ' ' + FORMAT_NUMBER.new(DocHeader.responseHeader.DocTotal) : ''}`} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">

                                <button type="button" className="btn btn-secondary ml-2" data-dismiss="modal" data-toggle="modal" data-target="#salesModal">Cerrar</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default SaleDetailsModal;